<template>
  <div class="frequently-used-container">
    <div class="text-right bg-frequent px-3 py-2" :class="{'is-active': toggle}">
      <b-link class="text-secondary" @click.native="frequentlyUsed">Frequently Used <b-img :src="require('@/assets/images/arrow-right.svg')"></b-img></b-link>
    </div>
    <Loader :text="searchQuery" v-if="loading" :loading="loading"/>

    <div class="frequently-used" v-if="searchResult[code] && toggle">
      <div class="px-3 pb-3 d-flex align-items-center" v-for="(code, i) in searchResult[code].codes.slice(0, 4)" :key="i">
        <span class="code-pill">{{ Object.keys(code)[0] }}</span>
        <span>{{ code[Object.keys(code)[0]] }}</span>
      </div>
      <div class="bg-frequent text-center px-3 py-2">
        <b-link class="font-weight-bold text-secondary montserrat" :to="{name: 'hsCode', params: {id: code}}"  @click.native="maClick('View Full List', code)">See full list</b-link>
      </div>
    </div>
  </div>
</template>
<script>
import ma from '../mixins/ma'
import { hsnQueryMixin } from '../mixins/query'
import Loader from '@/components/Loader'

export default {
  props: ['code'],
  data () {
    return {
      toggle: false,
      searchResult: [],
      count: 4,
      loading: false
    }
  },
  computed: {
    searchQuery () {
      return this.code
    }
  },
  methods: {
    async frequentlyUsed () {
      this.toggle = !this.toggle
      if (this.searchResult.length === 0) {
        await this.hsnQuery()
      }
      await this.maClick('Frequently Used', this.code)
    }
  },
  mixins: [ma, hsnQueryMixin],
  components: {
    Loader
  }
}
</script>

<style lang="scss" scoped>

.frequently-used-container {
  .frequently-used {
    .code-pill {
      padding: 0.2rem 1rem;
      font-size: 1.25rem;
      font-family: $font-family-sans-serif;
      font-weight: bold;
      border-radius: 2px;
      background: $light-blue;
      display: inline-block;
      margin-right: 1rem;
    }
  }
  .bg-frequent {
    background: $light-blue;
    a {
      text-decoration: none;
    }
    img {
      width: 10px;
      margin-right: 1rem;
      transition: transform .2s;
      transform: rotate(90deg);
    }
    &.is-active {
      background: white;
      img {
        top: 1px;
        transform: rotate(-90deg) translateX(2px);
      }
    }
  }
}
</style>
